import React from 'react';
import { connect } from 'react-redux';
import uniquid from 'uniqid';
import LinkButton from "../LinkButton";
import Button from '../Button';
import FieldRow from '../FieldRow';
import { authShowRecoverPass, authShowRegister } from '../../actions/creators';
import {loginPost,facebookLogin} from '../../actions/creators/auth';
import * as validators from '../../utils/validation';
import { openPopup } from '../../actions/creators/auth/apple';
import styled from 'styled-components';
import { useRecaptcha } from '../../hooks/useRecaptcha';

let emailId, passId;

const Container = styled.div`
  padding-top: 10rem;
  text-align: center;
`;

const Title = styled.h3`
  margin-bottom: 1rem;

  body.theme-market & {
    font-weight: 900 !important;
    font-size: ${(50/12.6).toFixed(2)}rem !important;
    margin-bottom: 1em;
  }

  body.theme-platinum & {
    color: var(--primary-b);
    font-weight: 700 !important;
    font-size: 2.1875rem !important;
    margin-bottom: 1em;
  }
`;

interface Props {
  getToken: (action: string) => Promise<string>;
  showRecoverPass: () => void;
  showRegister: () => void;
  loginPost: (email: string, password: string, captcha: string) => void;
  facebookLogin: () => void;
  appleLogin: () => void;
}

const LoginPanel: React.FC<Props> = ({ showRecoverPass, showRegister, loginPost, facebookLogin, appleLogin }) => {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const { getToken } = useRecaptcha();

  React.useEffect(() => {
    emailId = uniquid();
    passId = uniquid();
  }, []);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const captcha = await getToken('submit');

    loginPost(email, password, captcha);
  };

  return (
    <>
      <Container className="container">
        <Title className="title-1">¡Holaaaa!</Title>
        <p>Ingresa con tu usuario y contraseña.</p>

        <form onSubmit={onSubmit}>
          <FieldRow id={emailId} type="email" label="Email" onChange={(e) => setEmail(e.target.value)} value={email}/>
          <FieldRow id={passId} type="password" label="Contraseña" onChange={(e) => setPassword(e.target.value)} value={password}/>

          <div className='py-3'>
            <Button submit primary large block disabled={!validators.validateEmail(email) || !password}>Ingresar</Button>
          </div>
        </form>

        <div className="mt-3 mb-5">
          <LinkButton className="d-block mb-1" onClick={showRecoverPass}>¿Olvidaste tu contraseña?</LinkButton>
        </div>

        <div className="row pt-5 pb-3">
          <div className="col-6">
            <Button onClick={facebookLogin} block facebook className="mb-2"><i className="fab fa-facebook-f"></i></Button>
          </div>
          <div className="col-6">
            <Button onClick={appleLogin} block className="mb-2"><i className="fab fa-apple"></i></Button>
          </div>
        </div>
        <div>
          <LinkButton className="d-block mb-1" onClick={showRegister}>
            ¿No tienes cuenta? <span className="text-primary">Regístrate aquí</span>
          </LinkButton>
        </div>
      </Container>
    </>
  );
};


const mapDispatchToProps = dispatch => ({
  showRecoverPass: () => dispatch(authShowRecoverPass()),
  showRegister: () => dispatch(authShowRegister()),
  loginPost: (email, password, captcha) => dispatch(loginPost(email, password, captcha)),
  facebookLogin: () => dispatch(facebookLogin()),
  appleLogin: () => dispatch(openPopup())
});

export default connect(
    null,
    mapDispatchToProps
)(LoginPanel);